/**
 * City will have an image, but also contain state, use that as backup.
 * State will have an image, or else default?
 *
 * @param location
 */
import { LocationData, LocationDataCity, LocationDataState } from '@scenes/LocationPage/locationPage.types';

export const getSkyLineImage = (location: LocationData) => {
  const locationImage = location.skylineImage?.url;
  const backupImage = typeof location.state !== 'string' && location.state?.skylineImage?.url;
  const defaultImage = '';

  return [locationImage, backupImage, defaultImage].find(Boolean) as string;
};

export const smoothScroll = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

/**
 * Reusable item in which a user wants the city/state off of the payload
 * @param {LocationData} locationData
 * @returns {{city: string, state: string}}
 */
export const getCityStateLocationData = (locationData: LocationData) => {
  const { city } = locationData as LocationDataCity;
  const state = [locationData.state, (locationData.state as LocationDataState)?.displayName, ''].find(s => typeof s === 'string') as string;

  return { city, state };
};
